import { StateCallbacks } from "../../state";
import { Block, State } from "../../types";

export enum FontClass {
  Smaller = "font-size-smaller",
  Small = "font-size-small",
  Normal = "font-size-normal",
  Large = "font-size-large",
  Larger = "font-size-larger",
}

export interface IFontInformation {
  lowerBound: number;
  mode: number;
  upperBound: number;
}

export type Props<B extends Block> = Readonly<{
  block: B;
  blocks?: State["blocks"];
  confirmTableSelection?: boolean;
  disableTableSelectionConfirmation?: () => void;
  fontInformation?: IFontInformation;
  id: string;
  onAddCorrections?: StateCallbacks["onAddCorrections"];
  onSelectBlock?: StateCallbacks["onSelectBlock"];
  pages?: State["pages"];
  referencesLink?: React.ReactElement;
  selected: boolean;
  selectedCell: string | null;
  setShowReferences?: (blockId: string) => void;
}>;
